import React, { useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';
import DialogForm  from '../components/dialogForm.js';
import { fetch_retry } from "../service/getinfo.js";
import { numberWithCommas_display } from '../service/numberService.js';
import moment from 'moment';
var config = require('../../config.js');
var backend = config.backend;

const UpdateInfo = () => {
  const [formDialog, setFormDialog] = useState(false);
  const [deleteDonorDialog, setDeleteDonorDialog] = useState(false);
  const [selectedDonor, setSelectedDonor] = useState({});
  const [inputDate, setInputDate] = useState(null);
  const [inputText, setInputText] = useState(null);
  const [inputTransText, setInputTransText] = useState(null);
  const toastRef = React.useRef(null);
  const [errors, setErrors] = useState({
	"overseasCCDate": "",
	"overseasCCRate": "",
	"overseasCCTrans": "",
	"CCDate": "",
	"CCRate": "",
	"CCTrans": "",
	"CHQDate": "",
	"CHQRate": "",
	"CHQTrans": ""
  });
  const [tempParams, setTempParams] = useState({
	"overseasDonor": [],
	"overseasDonorText": null,
	"overseasDonorDate": null,
	"CCChange": null,
	"CCTransChange": null,
	"CCDateChange": null,
	"formDialog": false,
	"charges": [],
	"category": [],
	"previousOverseasDonor": [],
	"previousChargesRates": [],
	"CHQChange": null,
	"CHQTransChange": null,
	"CHQDateChange": null,
	"overseasChange": null,
	"overseasTransChange": null,
	"overseasDateChange": null
  })
  const [params, setParams] = useState({
	"overseasDonor": [],
	"overseasDonorText": "",
	"overseasDonorDate": "",
	"CCChange": 0.0,
	"CCTransChange": 0.0,
	"CCDateChange": "",
	"formDialog": false,
	"charges": [],
	"category": [],
	"previousOverseasDonor": [],
	"previousChargesRates": [],
	"CHQChange": 0.0,
	"CHQTransChange": 0.0,
	"CHQDateChange": "",
	"overseasChange": 0.0,
	"overseasTransChange": 0.0,
	"overseasDateChange": ""
  });

	useEffect(() => {
		const fetchData = async () => {
			var overseasDonor = [];
			var previousOverseasDonor = [];
			var chargesRatesData = [];
			var prevChargesRatesData = [];
			try {
				const overseasDonorsResponse = await fetch_retry(backend + 'api/params/overseasDonors', {
					method: 'GET',
					credentials: 'include'
				}, 3);
				const overseasDonorsData = await overseasDonorsResponse.json();
				overseasDonorsData.data.map(donor => (donor.Active === 1) ? overseasDonor.push({
					"name": donor.DonorName,
					"date": (donor.StartDate != null) ? moment(donor.StartDate).format('YYYY-MM-DD') : '',
					"category": "Overseas Donor"
				}) : previousOverseasDonor.push({
					"name": donor.DonorName,
					"date": (donor.StartDate != null) ? moment(donor.StartDate).format('YYYY-MM-DD') : '',
					"category": "Overseas Donor"
				}))
	
				const donationParamsResponse = await fetch_retry(backend + 'api/params/donationParams', {
					method: 'GET',
					credentials: 'include'
				}, 3);
				const donationParamsData = await donationParamsResponse.json();
				donationParamsData.data.map(chargeRate => (chargeRate.Active === 1) ? chargesRatesData.push({
					"rate": chargeRate.Rate,
					"date": (chargeRate.RateStartDate != null) ? moment(chargeRate.RateStartDate).format('YYYY-MM-DD') : '',
					"trans": chargeRate.TransactionRate,
					"category": chargeRate.PaymentTypeCode
				}) : prevChargesRatesData.push({
					"rate": chargeRate.Rate,
					"date": (chargeRate.RateStartDate != null) ? moment(chargeRate.RateStartDate).format('YYYY-MM-DD') : '',
					"trans": chargeRate.TransactionRate,
					"category": chargeRate.PaymentTypeCode
				}))
	
				setTempParams({
					...tempParams,
					"overseasDonor": overseasDonor,
					"previousOverseasDonor": previousOverseasDonor,
					"charges": chargesRatesData,
					"previousChargesRates": prevChargesRatesData
				});
	
				setParams({
					...params,
					"overseasDonor": overseasDonor,
					"previousOverseasDonor": previousOverseasDonor,
					"charges": chargesRatesData,
					"previousChargesRates": prevChargesRatesData
				});
			} catch (error) {
				console.error('Error fetching data:', error);
				// Handle error gracefully (e.g., display an error message)
			}
		};
	
		fetchData();
	}, []);

	const showToast = (severity, summary, detail) => {
		if (toastRef.current) {
		  toastRef.current.show({ severity, summary, detail });
		}
	};

	const inputOverseasCCValid = () => {
		let formIsValid = true;
		let error = {};
		let inputOverseasCCDate = tempParams.overseasDateChange;
		let inputOverseasCCChange = tempParams.overseasChange;
		let inputOverseasCCTransChange = tempParams.overseasTransChange;

		if (inputOverseasCCDate == null) {
			error['overseasCCDate'] = " Please choose a date!";
			formIsValid = false;

		}
		if (inputOverseasCCChange == null) {
			error['overseasCCRate'] = " Please enter a rate!";
			formIsValid = false;
		}
		if (inputOverseasCCTransChange == null) {
			error['overseasCCTrans'] = " Please enter a transaction rate!";
			formIsValid = false;
		}

		setErrors(error);
		return formIsValid;
    }

	const inputCCValid = () => {
		let formIsValid = true;
		let error = {};
		let inputCCDate = tempParams.CCDateChange;
		let inputCCChange = tempParams.CCChange;
		let inputCCTransChange = tempParams.CCTransChange;

		if (inputCCDate == null) {
			error['CCDate'] = " Please choose a date!";
			formIsValid = false;

		}
		if (inputCCChange == null) {
			error['CCRate'] = " Please enter a rate!";
			formIsValid = false;
		}
		if (inputCCTransChange == null) {
			error['CCTrans'] = " Please enter a transaction rate!";
			formIsValid = false;
		}

		setErrors(error);
		return formIsValid;
    }

	const inputCHQValid = () => {
		let formIsValid = true;
		let error = {};
		let inputCHQDate = tempParams.CHQDateChange;
		let inputCHQChange = tempParams.CHQChange;
		let inputCHQTransChange = tempParams.CHQTransChange;

		if (inputCHQDate == null) {
			error['CHQDate'] = " Please choose a date!";
			formIsValid = false;

		}
		if (inputCHQChange == null) {
			error['CHQRate'] = " Please enter a rate!";
			formIsValid = false;
		}
		if (inputCHQTransChange == null) {
			error['CHQTrans'] = " Please enter a transaction rate!";
			formIsValid = false;
		}

		setErrors(error);
		return formIsValid;
    }

	const inputDonorValid = () => {
		let formIsValid = true;
		let error = {};
		let inputDonorDate = tempParams.overseasDonorDate;
		let inputDonor = tempParams.overseasDonorText;

		// if (inputDonorDate == null) {
		// 	error['DonorDate'] = " Please choose a date!";
		// 	formIsValid = false;

		// }
		if (inputDonor == null) {
			error['Donor'] = " Please enter a donor name!";
			formIsValid = false;
		}

		setErrors(error);
		return formIsValid;
    }
	

	const onChange = (e) => {
		let selectedCategories = [...params.category];

        if (e.checked)
            selectedCategories.push(e.value);
        else
            selectedCategories.splice(selectedCategories.indexOf(e.value), 1);
		setTempParams({
			...tempParams,
			"category": selectedCategories
		});
	};

	const onAddingDonationParamsToSQL = (paramToAdd, oldParam) => {
		return new Promise((resolve, reject) => {
			fetch(backend + 'api/params/addDonationParams', {
				method: 'POST',
				credentials: 'include',
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					"new": paramToAdd,
					"old": oldParam
				})
			})
			.then((response) => response.json())
			.then((res) => {
				resolve(res.oldCode);
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			})
		})
	}

	const onDeletingOverseasDonorInSQL = (donorToDelete) => {
		return new Promise((resolve, reject) => {
			fetch(backend + 'api/params/deleteOverseasDonor', {
				method: 'DELETE',
				credentials: 'include',
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					"donor": donorToDelete
				})
			})
			.then((response) => response.json())
			.then((res) => {
				resolve(res.result);
			})
			.catch((error) => {
				console.error('Error fetching data:', error);
			})
		})
	}

	const onAddingOverseasDonorToSQL = async (donorToAdd) => {
		return await new Promise((resolve, reject) => {
			fetch(backend + 'api/params/addOverseasDonor', {
				method: 'POST',
				credentials: 'include',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					"new": donorToAdd
				})
			})
			.then(response => response.json())
			.then(response => {
				if (response.result !== 'done') {
					// If the response status is not OK, reject the promise with the error message from the server
					reject(response.result);
				} else {
					resolve(response.result);
				}
			})
			.catch (function (error) {
				console.error('Error fetching data:', error);
				reject(error);
			})
		});
	}

	const deleteSelectedDonor = async () => {
		let currentDonors = [...params.overseasDonor];
        let finalDonorsAfterDeletion = currentDonors.filter(donor => donor.name !== selectedDonor.name);
		await onDeletingOverseasDonorInSQL(selectedDonor.name);
		setParams({
			...params,
			"overseasDonor": finalDonorsAfterDeletion
		});
		setDeleteDonorDialog(false);
        showToast('success', 'Deleting Success', 'Deleted Overseas Donor successfully');
    }
	

	const onAddingOverseasDonor = async () => {
		try {
			if (inputDonorValid()) {
				let currentDonors = [...params.overseasDonor];
				let donorToAdd = {
					"name": tempParams.overseasDonorText,
					"date": tempParams.overseasDonorDate,
					"category": tempParams.checkCategories
				}
				let resultCode = await onAddingOverseasDonorToSQL(donorToAdd)
				if (resultCode == 'done') {
					currentDonors.push({
						"name": tempParams.overseasDonorText,
						"date": tempParams.overseasDonorDate,
						"category": tempParams.checkCategories
					});

				setParams({
					...params,
					"overseasDonor": currentDonors
				});
				setFormDialog(false);
				showToast('success', 'Adding Success', 'Added Overseas Donor successfully');
			} else {
				throw new Error('Failed to add donor');
				}
			}
		}
		catch (error) {
			console.error('Error adding overseas donor:', error);
			showToast('error', 'Adding Failure', 'Donor do not exist in database. Add an existing one.');
		}
	}

	const onAddingCCCharges = async () => {
		if (inputCCValid()) {
			let currentCCCharges = [...params.charges];
			let prevCCCharges = [...params.previousChargesRates];
			let paramToAdd = {
				"category": currentCCCharges[2].category,
				"rate": tempParams.CCChange,
				"trans": tempParams.CCTransChange,
				"date": tempParams.CCDateChange
			}
			
			let oldCode = await onAddingDonationParamsToSQL(paramToAdd, currentCCCharges[2]);
			prevCCCharges.push({
				"category": oldCode,
				"rate": currentCCCharges[2].rate,
				"trans": currentCCCharges[2].trans,
				"date": currentCCCharges[2].date
			});

			currentCCCharges[2].rate = tempParams.CCChange;
			currentCCCharges[2].trans = tempParams.CCTransChange;
			currentCCCharges[2].date = tempParams.CCDateChange

			setParams({
				...params,
				"charges": currentCCCharges,
				"previousChargesRates": prevCCCharges
			})
			setFormDialog(false);
			showToast('success', 'Adding Success', 'Added Creditcard Charge successfully');
		}
	}

	const onAddingCHQCharges = async () => {
		if (inputCHQValid()) {
			let currentCHQCharges = [...params.charges];
			let prevCHQCharges = [...params.previousChargesRates];
			let paramToAdd = {
				"category": currentCHQCharges[1].category,
				"rate": tempParams.CHQChange,
				"trans": tempParams.CHQTransChange,
				"date": tempParams.CHQDateChange
			}
			let oldCode = await onAddingDonationParamsToSQL(paramToAdd, currentCHQCharges[1]);
			prevCHQCharges.push({
				"category": oldCode,
				"rate": currentCHQCharges[1].rate,
				"trans": currentCHQCharges[1].trans,
				"date": currentCHQCharges[1].date
			})
			currentCHQCharges[1].rate = tempParams.CHQChange;
			currentCHQCharges[1].trans = tempParams.CHQTransChange;
			currentCHQCharges[1].date = tempParams.CHQDateChange

			setParams({
				...params,
				"charges": currentCHQCharges,
				"previousChargesRates": prevCHQCharges
			})
			setInputDate(1);
			setInputText(1);
			setInputTransText(1);
			setFormDialog(false);
			showToast('success', 'Adding Success', 'Added Cheque Charge successfully');
		}
	}

	const onAddingOverseasCharges = async () => {
		if (inputOverseasCCValid()) {
			let currentOverseasCharges = [...params.charges];
			let prevOverseasCharges = [...params.previousChargesRates];
			let paramToAdd = {
				"category": currentOverseasCharges[3].category,
				"rate": tempParams.overseasChange,
				"trans": tempParams.overseasTransChange,
				"date": tempParams.overseasDateChange
			}
			let oldCode = await onAddingDonationParamsToSQL(paramToAdd, currentOverseasCharges[3]);
			prevOverseasCharges.push({
				"category": oldCode,
				"rate": currentOverseasCharges[3].rate,
				"trans": currentOverseasCharges[3].trans,
				"date": currentOverseasCharges[3].date
			})
			currentOverseasCharges[3].rate = tempParams.overseasChange;
			currentOverseasCharges[3].trans = tempParams.overseasTransChange;
			currentOverseasCharges[3].date = tempParams.overseasDateChange

			setParams({
				...params,
				"charges": currentOverseasCharges,
				"previousChargesRates": prevOverseasCharges
			})
			setFormDialog(false);
			showToast('success', 'Adding Success', 'Added Overseas Charge successfully');
		}
	}


	const openNew = () => {
		setFormDialog(true);
	};

	const edit = (rowData) => {
		setTempParams({...tempParams, "overseasDonorText": rowData.name, "overseasDonorDate": rowData.date, "category": rowData.category})
		setFormDialog(true);
		
	}

	const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div>
                    <Button label="New" icon="pi pi-plus" severity="success" className="p-mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
	};

	const confirmDeleteDonor = (rowData) => {
		setSelectedDonor(rowData);
		setDeleteDonorDialog(true);
    }

	const onHide = () => {
		setFormDialog(false);
	}

	const hideDeleteDonorDialog = () => {
        setDeleteDonorDialog(false);
	}

	const paymentTypeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.category}
            </React.Fragment>
        );
    }

	const transBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {(rowData.trans !== null) ?'$' + numberWithCommas_display(rowData.trans) : ''}
            </React.Fragment>
        );
    }

	const paymentTypeRateBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {(numberWithCommas_display(rowData.rate*100.0)) + '%'}
            </React.Fragment>
        );
    }

	const nameBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {rowData.name}
            </React.Fragment>
        );
    }

	const dateBodyTemplate = (rowData) => {
		return (
			<React.Fragment>
				{rowData.date}
			</React.Fragment>
		);
	}

	const actionBodyTemplateForCharges = (rowData) => {
        return (
			<React.Fragment>
				<Button type="button" icon="pi pi-pencil" className="p-button-lg p-button-raised" onClick={() => edit(rowData)} disabled></Button>
				<Button type="button" icon="pi pi-times" className="p-button-danger p-button-lg p-button-raised" disabled></Button>
			</React.Fragment>
        );
    }

	const actionBodyTemplate = (rowData) => {
        return (
			<React.Fragment>
				<Button type="button" icon="pi pi-pencil" className="p-button-lg p-button-raised" onClick={() => edit(rowData)} disabled></Button>
				<Button type="button" icon="pi pi-times" className="p-button-danger p-button-lg p-button-raised" onClick={() => confirmDeleteDonor(rowData)}></Button>
			</React.Fragment>
        );
    }

	const actionBodyTemplateForOldData = () => {
        return (
			<React.Fragment>
				<Button type="button" icon="pi pi-pencil" className="p-button-lg p-button-raised" disabled></Button>
				<Button type="button" disabled icon="pi pi-times" className="p-button-danger p-button-lg p-button-raised"></Button>
			</React.Fragment>
        );
    }

	const renderHeader = (title) => {
        return (
            <div className="table-header">
                {title}
            </div>
        );
    }

	if (params.overseasDonor.length > 0) {
		return (
			<div className="grid crud-demo">
				<Toast ref={toastRef} />
				<div className="col-12">
					<div className="card">
						<Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>
                        <DialogForm 
							tempParams={tempParams}
							setTempParams={setTempParams}
							formState={formDialog}
							hideFunct={onHide}
							onChange={onChange}
							categories={tempParams.category}
							addOverseasDonor={onAddingOverseasDonor}
							addCC={onAddingCCCharges}
							addCHQ={onAddingCHQCharges}
							addOverseas={onAddingOverseasCharges}
							deleteMode={deleteDonorDialog}
							hideDeleteFunct={hideDeleteDonorDialog}
							deleteFunct={deleteSelectedDonor}
							deletedDonor={selectedDonor}
							errors={errors}
						/>
                        <TabView style={{ "fontSize": "1.5rem"}}>
							<TabPanel header="Overseas Donor" leftIcon="pi pi-user">
								<DataTable header={renderHeader("Current Overseas Donors")} value={params.overseasDonor} sortMode="multiple" style={{ "fontSize": "1.5rem"}}>
									<Column field="Donor Name" header="Donor Name" sortable body={nameBodyTemplate}  ></Column>
									<Column field="Start Date" header="Start Date" sortable body={dateBodyTemplate} ></Column>
									<Column body={actionBodyTemplate}/>
								</DataTable>
							</TabPanel>
							<TabPanel header="Charges Rate" leftIcon="pi pi-dollar">
								<DataTable header={renderHeader("Current Charges Rate")} value={params.charges} sortMode="multiple" style={{ "fontSize": "1.5rem"}}>
									<Column field="Payment Type" header="Payment Type" sortable body={paymentTypeBodyTemplate} ></Column>
									<Column field="Charge Rate" header="Charge Rate (%)" sortable body={paymentTypeRateBodyTemplate} ></Column>
									<Column field="Transaction Rate" header="Transaction Rate ($)" sortable body={transBodyTemplate} ></Column>
									<Column field="Start Date" header="Start Date" sortable body={dateBodyTemplate}></Column>
									<Column body={actionBodyTemplateForCharges}/>
								</DataTable>
							</TabPanel>
						</TabView>
                        <TabView style={{ "fontSize": "1.5rem"}}>
							<TabPanel header="Previous Overseas Donor" leftIcon="pi pi-user">
								<DataTable header={renderHeader("Previous Overseas Donors")} value={params.previousOverseasDonor} sortMode="multiple" style={{ "fontSize": "1.5rem"}}>
									<Column field="Donor Name" header="Donor Name" sortable body={nameBodyTemplate}  ></Column>
									<Column field="Start Date" header="Start Date" sortable body={dateBodyTemplate} ></Column>
									<Column body={actionBodyTemplateForOldData}/>
								</DataTable>
							</TabPanel>
							<TabPanel header="Previous Charges Rate" leftIcon="pi pi-dollar">
								<DataTable header={renderHeader("Previous Charges Rate")} value={params.previousChargesRates} sortMode="multiple" style={{ "fontSize": "1.5rem"}}>
									<Column field="Payment Type" header="Payment Type" sortable body={paymentTypeBodyTemplate} ></Column>
									<Column field="Charge Rate" header="Charge Rate (%)" sortable body={paymentTypeRateBodyTemplate} ></Column>
									<Column field="Transaction Rate" header="Transaction Rate ($)" sortable body={transBodyTemplate} ></Column>
									<Column field="Start Date" header="Start Date" sortable body={dateBodyTemplate}></Column>
									<Column body={actionBodyTemplateForOldData}/>
								</DataTable>
							</TabPanel>
						</TabView>
					</div>
				</div>
			</div>
			
		)
	} else {
		return (
			<h2>Loading...</h2>
		)
	}
}

export default UpdateInfo;